import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useAlgoliaAppContext } from './useAlgoliaAppContext';
import { FACET_KEY_MEDIUMS } from '../constants/facetKeys';
import { SEARCH_PARAM_KEY_PAGE_NUMBER } from '../constants/searchParamKeys';
import { handleize } from '../../js/helpers/handleize';
import { updateFilterValueInSearchParams } from '../utils/updateFilterValueInSearchParams';
export const useFacetLogic = (key, singleSelect = false) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const { medium, handle } = useParams();
    const { pagePath } = useAlgoliaAppContext();
    const navigate = useNavigate();
    let activeValues;
    let itemClickHandler;
    searchParams.delete(SEARCH_PARAM_KEY_PAGE_NUMBER);
    if (key === FACET_KEY_MEDIUMS) {
        activeValues = medium !== undefined
            ? [medium.replace(/-/g, ' ')]
            : [];
        itemClickHandler = (value) => {
            const searchString = searchParams.toString();
            let pathname = `/${pagePath}`;
            if (handle !== undefined) {
                pathname += `/${handle}`;
            }
            if (value !== undefined && !activeValues.includes(value)) {
                pathname += `/${handleize(value)}`;
            }
            navigate({
                pathname,
                ...(searchString.length > 0 && { search: `?${searchString}` })
            });
        };
    }
    else {
        const value = searchParams.get(key);
        activeValues = value !== null
            ? value.split(',')
            : [];
        itemClickHandler = (value) => {
            if (value === undefined) {
                searchParams.delete(key);
                searchParams.sort();
                setSearchParams(searchParams);
                return;
            }
            const newParams = updateFilterValueInSearchParams({
                searchParams, activeValues, value, key, singleSelect
            });
            newParams.sort();
            setSearchParams(newParams);
        };
    }
    return [activeValues, itemClickHandler];
};
